import usePdpAtom from '../usePDPAtom';

const usePdpLastSelectedOptionIdAtom = () => {
  const pdpLastSelectedOptionIdAtom = usePdpAtom(
    'pdpLastSelectedOptionIdAtom',
    ''
  );

  return pdpLastSelectedOptionIdAtom;
};

export default usePdpLastSelectedOptionIdAtom;
